import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUsers } from '../../redux/actions/users';
import { ContainerFull } from '../../components/ContainerFull';
import { Heading } from '../../components/Heading';
import { Wrapper } from '../../components/Wrapper';
import { AddNewUserModal } from './AddNewUserModal';
import { UserIcon, UserPlusIcon } from '@heroicons/react/20/solid';
import { Loading } from '../../components/loading/Loading';
import { Tooltip, Zoom } from '@mui/material';
import { formatDate } from '../../common/formatDateText';
import { DataTableCustom } from '../../components/dataTable/DataTableCustom';

export const UsersPage = () => {
	const dispatch = useDispatch();

	const {
		users,
		loading,
	} = useSelector((state) => state.users);
	const timeoutRef = useRef(null);

	const [rows, setRows] = useState([]);
	const [pageSizeOptions, setpageSizeOptions] = useState({
		pageSize: 10,
		page: 0,
		totalRows: 0
	});

	const [openAddNewUserModal, setOpenAddNewUserModal] = useState(false);
	const [searchText, setSearchText] = useState('');

	useEffect(() => {
		dispatch(getAllUsers(pageSizeOptions.page, pageSizeOptions.pageSize, searchText))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}, []);

	useEffect(() => {
		setRows(users)
	}, [users]);

	const handlePageChange = (model) => {
		setpageSizeOptions(model);
		dispatch(getAllUsers(model.page, model.pageSize, searchText))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}

	const handleSearchChange = (e) => {
		setSearchText(e.target.value);
		// Cancelamos el timeout anterior si el usuario sigue escribiendo
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		// Esperamos 500ms desde el último cambio antes de ejecutar la lógica
		timeoutRef.current = setTimeout(() => {
			// ya puedes hacer fetch, actualizar estado global, etc.
			searchUserByQuery(e.target.value);
		}, 1000);
	}

	const searchUserByQuery = (query) => {
		dispatch(getAllUsers(0, 10, query))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}

	const columns = [
		{
			field: 'action',
			headerName: '',
			sortable: false,
			width: 150,
			disableColumnMenu: true,
			renderCell: (params) => (
				<div className='w-full flex justify-center gap-4'>
					<Tooltip title="Ver perfil de usuario" TransitionComponent={Zoom} placement='left'>
						<Link
							to={`/perfil/${params.id}`}
							className="flex justify-center border-gray-200 border-1 bg-gray-100 uppercase px-3 py-2 text-slate-700 rounded hover:bg-gray-300"
						>
							<UserIcon className="block h-5 w-5" aria-hidden="true" />
						</Link>
					</Tooltip>
				</div>
			),
		},
		{
			field: 'userName',
			headerName: 'Nombre de usuario',
			width: 350,
			renderCell: (params) => (
				<p className='capitalize'>{`${params.row.userName}`}</p>
			),
		},
		{
			field: 'email',
			headerName: 'Correo Electronico',
			width: 300,
		},
		{
			field: 'location',
			headerName: 'Ubicacion',
			width: 180,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{ field: 'phone', headerName: 'Telefono', width: 150 },
		{
			field: 'typeUser',
			headerName: 'Tipo de usuario',
			width: 180,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{
			field: 'createdAt',
			headerName: 'Fecha de registro',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize w-[200px] text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{formatDate(params.value)}</p>
			)
		},
	];

	return (
		<ContainerFull>
			<Heading
				title={`Lista de personal`}
				subtitle={`Muestra la lista de todo el personal registrados en el plataforma.`}
				center={false}
			/>

			<div className='w-full flex justify-end mt-4'>
				<Tooltip title="Agregar un nuevo usuario administrativo" TransitionComponent={Zoom} placement='top'>
					<button
						type='button'
						onClick={() => setOpenAddNewUserModal(true)}
						className='rounded-md px-4 py-2 font-semibold text-md text-white bg-indigo-600 shadow-sm shadow-indigo-600 hover:bg-indigo-800'
					><UserPlusIcon className="block h-5 w-5" aria-hidden="true" /></button>
				</Tooltip>
			</div>

			{users && (
				<>
					<Wrapper>
						<input
							type="text"
							placeholder="Buscar a un usuario"
							value={searchText}
							onChange={handleSearchChange}
							className='block w-full rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6' />
					</Wrapper>

					<Wrapper>
						{
							loading ? (
								<Loading />
							) : (
								<div className='overflow-x-auto'>
									{
										rows.length > 0
											? (
												<DataTableCustom
													rows={rows}
													columns={columns}
													pageSizeOptions={pageSizeOptions}
													onPageChange={handlePageChange}
												/>
											) : (
												<p className='text-gray-400'>No hay registro del usuario</p>
											)
									}
								</div>
							)

						}
					</Wrapper>
				</>
			)}
			<AddNewUserModal
				open={openAddNewUserModal}
				setOpen={setOpenAddNewUserModal}
			/>
		</ContainerFull>
	);
}
